import React, { useEffect, useState } from 'react';
import { Flex, Select, Typography } from 'antd';
import { FormikProps } from 'formik';

import { generateOptions } from '../utils/periodGenerator';
import { useReadChatsQuery } from '../../Chats/service/chat.api';
import { RecommendationsProps } from '../service/recommendations.interface';

const { Text } = Typography;

const PAGE_SIZE = 10;

interface OptionProps {
    label: string;
    value: string;
}

export const RecommendationsForm = ({
    formik,
}: {
    formik: FormikProps<RecommendationsProps>;
}) => {
    const periods = generateOptions(7);

    const [page, setPage] = useState(0);
    const [chats, setChats] = useState<OptionProps[]>([
        { label: 'Все сообщества', value: '0' },
    ]);
    const [hasMore, setHasMore] = useState(true);

    const { data, isFetching, isSuccess } = useReadChatsQuery({
        offset: page * PAGE_SIZE,
        limit: PAGE_SIZE,
    });

    useEffect(() => {
        if (isSuccess && data) {
            const newOptions = data.items.map(chat => ({
                label: chat.title,
                value: String(chat.id),
            }));

            setChats(prev => {
                const existingIds = new Set(prev.map(opt => opt.value));
                const filteredNew = newOptions.filter(
                    opt => !existingIds.has(opt.value)
                );
                return [...prev, ...filteredNew];
            });

            setHasMore(data.items.length === PAGE_SIZE);
        }
    }, [data, isSuccess]);

    const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
        const target = e.currentTarget;
        if (
            target.scrollTop + target.offsetHeight >=
                target.scrollHeight - 10 &&
            !isFetching &&
            hasMore
        ) {
            setPage(prev => prev + 1);
        }
    };

    const handleSelect = (name, value) => {
        formik.setFieldValue(name, value);
    };

    return (
        <Flex gap={24} vertical>
            <Flex gap={4} vertical>
                <Text>Период</Text>
                <Select
                    onChange={value => handleSelect('period', value)}
                    showSearch
                    placeholder='Выберите период в днях'
                    options={periods}
                    value={formik.values.period}
                />
            </Flex>
            <Flex gap={4} vertical>
                <Text>Сообщества</Text>
                <Select
                    onChange={value => handleSelect('community_ids', value)}
                    onPopupScroll={handleScroll}
                    loading={isFetching}
                    showSearch
                    mode='multiple'
                    value={formik.values.community_ids}
                    maxTagCount={'responsive'}
                    placeholder='Выберите сообщества'
                    options={chats}
                />
            </Flex>
        </Flex>
    );
};
